"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toS3Image = toS3Image;
function toS3Image(img, order, source) {
    /**
     * Example image: https://media.mlsgrid.com/token=CXhJZShR8i77JRUWUBaPvMRcxgOkB3HdBDWr6Yt_8Ck&expires=1761804858&id=6763458b11f6a958d51e1883/images/KEY322063096/8030378b-d6a7-4487-b77b-f29f2ed844e7.jpeg
     *
     * As of Thu Oct 30 06:37:54 AM UTC 2025, we are significantly modifying the URLs. Instead of the above url, it would look like:
     * https://media.mlsgrid.com/$&id=6763458b11f6a958d51e1883/images/KEY322063096/8030378b-d6a7-4487-b77b-f29f2ed844e7.jpeg
     *
     * As far as the code below, it should still work.
     */
    const url = new URL(img);
    if (source === 'onekey') {
        const base_url = new URL("https://lombardo.nyc3.digitaloceanspaces.com/mls/");
        const parts = url.pathname.split("/");
        let jpg_name = parts[parts.length - 1];
        return {
            order,
            src: new URL(base_url + jpg_name),
            thumb: new URL(base_url + `th_${jpg_name}`),
        };
    }
    if (typeof img === 'string') {
        return {
            order,
            src: new URL(img.replace(/\/thumb$/, '/public')),
            thumb: new URL(img),
        };
    }
    return {
        order,
        src: new URL(img.toString().replace(/\/thumb$/, '/public')),
        thumb: new URL(img),
    };
}
